// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2wqma","label":"Labeled_label__12KLY","divider":"Labeled_divider__1N4bJ"};